import { RefObject, useEffect, useState } from 'react';

export const useLoad = (ref: RefObject<HTMLImageElement | null>) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = ref.current;
    const update = () => setLoaded(true);

    if (!img) {
      return;
    }

    if (img.complete) {
      update();
    }

    img.addEventListener('load', update);

    return () => img.removeEventListener('load', update);
  }, [ref, setLoaded]);

  return loaded;
};
